/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Page_SubtitleInputs */

const vi_warehouse_defects_page_subtitle = /** @type {(inputs: Warehouse_Defects_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng hợp theo kỳ và sản phẩm. Lọc theo lý do bên dưới.`)
};

/**

* @param {Warehouse_Defects_Page_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_page_subtitle = /** @type {((inputs?: Warehouse_Defects_Page_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Page_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_page_subtitle(inputs)
});